__turbopack_context__.v({
  "className": "pretendard_497eefd6-module__-Le6sq__className",
  "variable": "pretendard_497eefd6-module__-Le6sq__variable",
});
